import React from 'react';
import {useNavigate} from 'react-router-dom';

import {AlertActions, AlertModal} from 'presentation/components';
import {SelectionFlowEnum} from 'presentation/constants';

import {translations} from 'presentation/translations-new';

import {useIsComingFromInitialFlowStore} from 'presentation/pages/others/selection-flow/store/useIsComingFromInitialFlowStore';
import {useOperationalCostStore} from 'presentation/hooks/useOperationalCostPassword/store';
import {ChangePlanDialogProps} from './types';

const {
	changeState: {title, description},
	title: confirmText,
} = translations['pt-br'].privateFlow.bookingFlow.changePlanFlow;
const {notice, cancel} = translations['pt-br'].commons;

function ChangePlanDialog({open, setOpen}: ChangePlanDialogProps) {
	const navigate = useNavigate();
	const resetIsOperationalCostAuthorizedState = useOperationalCostStore(
		state => state.resetIsOperationalCostAuthorized,
	);
	const resetIsComingFromInitialFlow = useIsComingFromInitialFlowStore(
		state => state.resetIsComingFromInitialFlow,
	);

	function handleConfirmChangePlan() {
		resetIsComingFromInitialFlow();
		resetIsOperationalCostAuthorizedState();
		setOpen(false);
		navigate(SelectionFlowEnum.PLAN_SELECTION, {
			replace: true,
		});
	}

	return (
		<AlertModal
			customIconName="info-filled"
			footerContent={
				<AlertActions
					flexDirection="column-reverse"
					primaryAction={handleConfirmChangePlan}
					secondaryAction={() => setOpen(false)}
					secondaryText={cancel}
					primaryText={confirmText}
				/>
			}
			description={description}
			headerTitle={notice}
			onClose={() => setOpen(false)}
			title={title}
			open={open}
			variant="info"
		/>
	);
}

export {ChangePlanDialog};
